<template>
<div class="size margin">

  <div class="example">
    <titleComponent value="Buttons" mark="01" color="background-yellow" />

    <div class="container column padding-top-20 border-box padding-20">

      <div class="container column esp flex-grow-1">
        <div class="subtitle">
          <h4>Type</h4>
        </div>
        <div class="esp container wrap align-items-center">
          <button type="button" name="button" class="btn">Medium</button>
          <button type="button" name="button" class="btn btn-outline">Medium</button>
          <button type="button" name="button" class="btn btn-rounded">Medium</button>
          <button type="button" name="button" class="btn btn-rounded btn-outline">Medium</button>
        </div>
      </div>

      <div class="container column esp flex-grow-1">
        <div class="subtitle">
          <h4>Size</h4>
        </div>
        <div class="esp container wrap align-items-center">
          <button type="button" name="button" class="btn btn-rounded btn-sm">Small</button>
          <button type="button" name="button" class="btn btn-rounded">Medium</button>
          <button type="button" name="button" class="btn btn-rounded btn-lg">Large</button>
        </div>
      </div>

      <div class="container column esp flex-grow-1">
        <div class="subtitle">
          <h4>Full width</h4>
        </div>
        <div class="esp container wrap align-items-center">
          <button type="button" name="button" class="btn btn-rounded btn-sm btn-full">Small</button>
          <button type="button" name="button" class="btn btn-rounded btn-full">Medium</button>
          <button type="button" name="button" class="btn btn-rounded btn-lg btn-full">Large</button>
        </div>
      </div>

      <div class="container column esp flex-grow-1">
        <div class="subtitle">
          <h4>Color</h4>
        </div>
        <div class="esp container wrap align-items-center">
          <button type="button" name="button" class="btn btn-rounded btn-red">Button red</button>
          <button type="button" name="button" class="btn btn-rounded btn-blue">Button blue</button>
          <button type="button" name="button" class="btn btn-rounded btn-green">Button green</button>
          <button type="button" name="button" class="btn btn-rounded btn-yellow">Button yellow</button>
        </div>

        <div class="esp container wrap align-items-center">
          <button type="button" name="button" class="btn btn-rounded btn-outline btn-red">Button red</button>
          <button type="button" name="button" class="btn btn-rounded btn-outline btn-blue">Button blue</button>
          <button type="button" name="button" class="btn btn-rounded btn-outline btn-green">Button green</button>
          <button type="button" name="button" class="btn btn-rounded btn-outline btn-yellow">Button yellow</button>
        </div>
      </div>

      <div class="container column esp flex-grow-1">
        <div class="subtitle">
          <h4>Icons</h4>
        </div>
        <div class="esp container wrap align-items-center">
          <button type="button" name="button" class="btn btn-rounded btn-red"><i class="fas fa-times"></i></button>
          <button type="button" name="button" class="btn btn-rounded btn-red">SALA VIRTUAL <i class="margin-left-10 fas fa-arrow-right"></i></button>
          <button type="button" name="button" class="btn btn-rounded btn-yellow">ENTRAR <i class="margin-left-10 fas fa-user"></i></button>
        </div>
      </div>


    </div>
  </div>

</div>
</template>

<script>
import titleComponent from '@/components/titleComponent'

export default {
  components: {
    titleComponent,
  },
  name: 'buttons',
  data () {
    return {}
  }
}
</script>

<style lang="scss" scoped>
.ex-btn {
    padding-bottom: 100px;
}
.esp {
    margin-bottom: 10px;
}

.example .btn {
  margin: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/styleguide/buttons.vue